import { END } from 'redux-saga';
import { takeMaybe } from 'redux-saga/effects';

// Remove this after https://github.com/redux-saga/redux-saga/pull/1493
export default function* closeChannelOnEnd(channel: any) {
  yield takeMaybe(END.type);
  channel.close();
}
